import React, {useRef, useState} from "react";
import useOutsideClickHandler from '../base/useOutsideClickHandler';

export default function MultiSelect(props) {

    const [active, setActive] = useState(false);
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => setActive(false));
    const testStatuses= [{value: 'none', label: 'All test statuses'}];
    if (props.full_access || props.interests_access) {testStatuses.push({value: 'interests', label: 'Career Interests Complete'})}
    if (props.full_access || props.personality_access) {testStatuses.push({value: 'personality', label: 'Work Personality Complete'})}
    if (props.full_access || props.motivators_access) {testStatuses.push({value: 'motivators', label: 'Career Motivators Complete'})}
    if (props.full_access || props.abstract_access) {testStatuses.push({value: 'abstract', label: 'Abstract Reasoning Complete'})}
    if (props.full_access || props.numerical_access) {testStatuses.push({value: 'numerical', label: 'Numerical Reasoning Complete'})}
    if (props.full_access || props.verbal_access) {testStatuses.push({value: 'verbal', label: 'Verbal Reasoning Complete'})}

    const selectedValueText = !props.test_status || props.test_status === 'none' ? 'All Test Statuses' : props.test_status === 'all' ? 'All Tests Complete' : 'Custom';
    return (
     <div className={`users__dropdown-container ${active ? 'active' : ''}`} ref={wrapperRef}>
         <label className={`users__dropdown users__dropdown--label`} onClick={() => setActive(!active)}><span
             className="users__dropdown--label__title">{selectedValueText}
             {selectedValueText === "Custom" ? <span className="filter-tabs__notification"/> : null}
         </span></label>
         <div className="users__dropdown users__dropdown--list">
             {testStatuses.map((status) => {
                 return <label className="users__dropdown__option input-tick addAnimation" key={status.value}>
                            <input type="checkbox" name={status.value}
                                   onChange={props.onChange}
                                   checked={props.test_status === status.value || (props.test_status === 'custom' && props.custom_statuses.includes(status.value))}/>
                           <span className="checkbox-material"><span className="custom-checkbox"/></span>
                           <span className="check-text">{status.label}</span>
                 </label>;
             })}
         </div>
     </div>
    )

}
